import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";

const VehicleModal = ({ showModal, closeModal, onSelectVehicle, branch, rowIndex }) => {
  const [vehicles, setVehicles] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false); // ✅ new state

  useEffect(() => {
    if (showModal) {
      fetchVehicles();
    }
  }, [showModal, search]); // Re-fetch when modal opens or search changes

  const fetchVehicles = async () => {
    setLoading(true); // ✅ start loading
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/get_vehicles", {
        params: { branchcode: branch, searchTerm: search }
      });
      setVehicles(response.data || []);
    } catch (error) {
      console.error("Error fetching vehicles:", error);
    } finally {
      setLoading(false); // ✅ stop loading
    }
  };

  const ownVehicles = vehicles.filter(v => v.source === "own");
const hireVehicles = vehicles.filter(v => v.source === "hire");
const subDepartments = vehicles.filter(v => v.source === "subdept");


  const handleSelect = (vehicle_code, vehicle_number) => {
    onSelectVehicle(vehicle_code, vehicle_number);
    closeModal();
  };

  return (
    <div className={`custom-modal-overlay ${showModal ? "visible" : ""}`}>
      <div className="custom-modal">
        <div className="custom-modal-header">
          <h2>Select Vehicle</h2>
          <button className="custom-modal-close" onClick={closeModal}>✖</button>
        </div>

        <input
          type="text"
          className="custom-modal-search"
          placeholder="Search Vehicle Code or Name..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

       <div className="custom-modal-list">
  {loading ? (
    <p className="custom-loading">Loading vehicles...</p>
  ) : (
    <>
      {/* Own Vehicles */}
      {ownVehicles.length > 0 && (
        <>
          <h3 style={{color:'red'}}>Own Vehicles</h3>
          {ownVehicles.map((vehicle, index) => (
            <div
              key={`own-${index}`}
              className="custom-modal-item"
              onClick={() => handleSelect(vehicle.vehicle_code, vehicle.vehicle_number)}
            >
              {vehicle.vehicle_code} - {vehicle.vehicle_number}
            </div>
          ))}
        </>
      )}

      {/* Hire Vehicles */}
      {hireVehicles.length > 0 && (
        <>
          <h3 style={{color:'red'}}>Hire Vehicles</h3>
          {hireVehicles.map((vehicle, index) => (
            <div
              key={`hire-${index}`}
              className="custom-modal-item"
              onClick={() => handleSelect(vehicle.vehicle_code, vehicle.vehicle_number)}
            >
              {vehicle.vehicle_code} - {vehicle.vehicle_number}
            </div>
          ))}
        </>
      )}

      {/* Sub Departments */}
      {subDepartments.length > 0 && (
        <>
          <h3 style={{color:'red'}}>Sub Departments</h3>
          {subDepartments.map((vehicle, index) => (
            <div
              key={`sub-${index}`}
              className="custom-modal-item"
              onClick={() => handleSelect(vehicle.vehicle_code, vehicle.vehicle_number)}
            >
              {vehicle.vehicle_code} - {vehicle.vehicle_number}
            </div>
          ))}
        </>
      )}

      {/* If no results */}
      {vehicles.length === 0 && <p className="custom-no-data">No vehicles found.</p>}
    </>
  )}
</div>

      </div>
    </div>
  );
};

export default VehicleModal;
